import React from "react";
import { isIntelligentInvestorDomain } from "../../../utils/utils";
import { AuthenticationProviderType, UpsellPanelSteps } from "../../../constants/upsellPanelEnumsAndConstants";
import Helpers from "../../../constants/helpers";
import { useUpsellWidgetModel } from "../hooks/useUpsellWidgetModelContext";
import { useUpsellWidgetContainer } from "../hooks/useUpsellWidgetContainerContext";
import classNames from "classnames";

const OAuthArticlesLoginPanel = () => {
  const model = useUpsellWidgetModel();
  const { currentStep } = useUpsellWidgetContainer();
  const cssClass = isIntelligentInvestorDomain() ? "font-open-sans font-weight-semibold" : "font-circular-std-bold"
  const isSignupStep = currentStep === UpsellPanelSteps.Step1SignUp;

  const primaryColorClass = model.isCompetitionPage ? model.textPrimaryColor : "";
  const privacyLinkCss = classNames(
    (model.isCompetitionPage) &&
    ["text-underline", model.textPrimaryColor]);

  return (
    <>
      <div className={`oauth-divider my-2 ${cssClass}`}>
        <span className={`px-2 ${primaryColorClass}`}>OR</span>
      </div>

      {isSignupStep && (
        <div className={`font-16 text-color-gray-53 t-c ${cssClass} ${primaryColorClass}`}>
          Sign up with
        </div>
      )}

      {(currentStep === UpsellPanelSteps.Step8ExistingUserLogin ||
        currentStep === UpsellPanelSteps.Step3Login) && (
          <div className={`font-16 text-color-gray-53 t-c ${cssClass} ${primaryColorClass}`}>
            Login with
          </div>
        )}

      {/* Social Login Buttons */}
      <div className="d-flex justify-content-center">
        {/* Google Login */}
        <div className="form-is-custom form-disable-pristine-error mr-4 cursor-pointer" onClick={() => handleExternalUser(AuthenticationProviderType.Google, model.entryPoint)}        >
          <div className="mt-2 shadow-hover border-rad-4">
            <img src={Helpers.getBlobFileUrl("/images/google_logo.svg")} alt="Google Login" title="Google Login" />
          </div>
        </div>

        {/* Facebook Login */}
        <div
          className="form-is-custom form-disable-pristine-error cursor-pointer"
          onClick={() => handleExternalUser(AuthenticationProviderType.Facebook, model.entryPoint)}
        >
          <div className="mt-2 shadow-hover border-rad-4">
            <img src={Helpers.getBlobFileUrl("/images/facebook_logo.svg")} alt="Facebook Login" title="Facebook Login" />
          </div>
        </div>
      </div>
      {!isSignupStep && (
        <>
          <div className={`terms-text t-c mb-10 mt-2 text-color-gray-53 ${primaryColorClass}`}>By continuing, you agree to our</div>
          <p className="terms-links text-center">
            <a href="/terms-and-conditions" target="_blank" rel="noreferrer" className={privacyLinkCss}>Terms of Use</a>
            <span className={model.isCompetitionPage ? model.textPrimaryColor : "text-color-gray-53"} > & </span>
            <a href="/privacy-policy" target="_blank" rel="noreferrer" className={privacyLinkCss}>Privacy Policy</a >
          </p>
        </>
      )}
    </>
  );
};

export default OAuthArticlesLoginPanel;
